import { View, ScrollView } from "react-native";
import {
  ConnectNotificationBanner,
  ConnectPayments,
} from "@stripe/react-connect-js";
import { useSettingsData } from "../../contexts/SettingsDataContext";
import LoadingView from "../../components/common/loading-view";
import { useActiveAgent } from "../../contexts/ActiveAgentContext";
import { useStripeClientSecret } from "../../contexts/StripeClientSecretContext";
import StyledText from "../../components/common/ui/styled-text";

const Transactions = () => {
  const { clientSecret } = useStripeClientSecret();
  const { activeAgent } = useActiveAgent();
  const { settings, isLoading } = useSettingsData();
  const connectedAccountId = settings?.stripeAccountId;

  if (!clientSecret || !connectedAccountId || !activeAgent) {
    return null;
  }

  if (isLoading) {
    return <LoadingView backgroundColor="bg-[#f2f2f2]" />;
  }

  return (
    <ScrollView className="flex-1 bg-gray-50">
      <View className="p-0 sm:p-6 space-y-4">
        <ConnectNotificationBanner />
        <View className="bg-white sm:rounded-lg sm:border sm:border-gray-200 overflow-hidden">
          <View className="p-2 sm:p-4 border-b border-gray-200">
            <StyledText className="text-lg font-semibold text-gray-900">
              Transactions
            </StyledText>
            <StyledText className="text-sm text-gray-600">
              View detailed transaction history
            </StyledText>
          </View>
          <View className="bg-white p-2 sm:rounded-2xl sm:p-6 sm:shadow-sm">
            <ConnectPayments />
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

export default Transactions;
